import React from "react";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  Row,
  Col
} from "reactstrap";
import "./scheduleLessons.css";
import Navbar from "../../components/CustomNav/CustomNav.Component";
import { Redirect } from "react-router-dom";
import {
  currentBaseUrl,
  createItemGen,
  currentLesson,
  getGeneralSmartTableData,
  selectedCalendarDay
} from "src/common/services";
import { CSSTransition } from "react-transition-group";

import dragDropIcon from "../../assets/images/dragdrop-icon.png";
// import { Button } from '@material-ui/core';

// toast component
import { toast, ToastContainer } from "react-toastify";
import CustomCalendar from "../../common/Lessons/customCalendar.Component";

class DNDCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // activities: upcomingActivities,
      allocations: [],
      destination: "",
      events: [],
      navigateBack: false,
      toLogin: false,
      toProfile: false
    };
    // this.moveEvent = this.moveEvent.bind(this);
    // this.newEvent = this.newEvent.bind(this);
    // this.fillUpcomingActivities = this.fillUpcomingActivities.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.handleAllocationsLoaded = this.handleAllocationsLoaded.bind(this);
    this.handleRequestCompleted = this.handleRequestCompleted.bind(this);
    this.getEndTime = this.getEndTime.bind(this);
    this.onDragStop = this.onDragStop.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
  }

  componentDidMount() {
    getGeneralSmartTableData("overview/lesson_allocations", text =>
      this.handleAllocationsLoaded(text)
    );
  }

  handleRequestCompleted(res, prevevents) {
    if (res.code === 200) {
      getGeneralSmartTableData("overview/lesson_allocations", text =>
        this.handleAllocationsLoaded(text)
      );
      toast.success("Reschedule Successful");
    } else {
      toast.error("Sorry, request failed");
      this.setState({
        events: prevevents
      });
    }
  }

  handleAllocationsLoaded(res) {
    if (res.code === 200) {
      console.log(
        "Allocations loaded" +
          JSON.stringify(res.response.lessonallocations, null, 4)
      );
      const tempevents = [];
      for (var i = 0; i < res.response.lessonallocations.length; i++) {
        const curritem = res.response.lessonallocations[i];
        const evt = {
          Id: curritem.id,
          Subject: curritem.Title,
          StartTime: new Date(curritem.DueDate),
          EndTime: this.getEndTime(curritem.DueDate, curritem.Duration),
          LessonId: curritem.LessonId
        };
        // console.log("All ALLocs: " + JSON.stringify(evt, null, 4));
        tempevents.push(evt);
      }

      this.setState({
        allocations: res.response.lessonallocations,
        events: tempevents
      });
    }
  }

  onDragStop(args) {
    const currentEvent = args.data;
    const events = this.state.events;
    const prevEvtIdx = this.getEventIndex(events, "LessonId", currentEvent.LessonId
    );
    // const lessonId = currentEvent.LessonId;
    const lessonidx = currentEvent.Id;
    const item = {
      Time: currentEvent.StartTime.getTime() / 1000
    };
    if (events[prevEvtIdx].StartTime < new Date() || currentEvent.StartTime < new Date()) {
      toast.error("You Cannot Change The Past!");
      this.setState({ events });
    } else {
      createItemGen(
        "lesson_allocations/" + lessonidx + "/reschedule/",
        item,
        text => this.handleRequestCompleted(text, events)
      );
    }
  }
  onDragStart(args) {
    console.log(args.data);
  }

  onResizeStop(args) {
    console.log("ONRESIZE: " + JSON.stringify(args.data));
  }
  onCellClick(args) {
    console.log("ONCELLCLICK: " + JSON.stringify(args));
  }
  onClicking(args) {
    console.log("ONCLICK: " + JSON.stringify(args.event));
  }
 

  getEndTime(dateString, duration) {
    const date = new Date(dateString);
    date.setHours(date.getHours() + duration);
    return date;
  }

  getEventIndex(array, attr, val) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][attr] === val) {
        return i;
      }
    }
  }

  openWidget(param, e) {
    this.setState({ destination: currentBaseUrl() + param });
    this.setState({ navigateBack: true });
  }

  onLogout() {
    this.setState({ toLogin: true });
  }

  onProfile() {
    this.setState({ toProfile: true });
  }

  render() {
    console.log(this.state.events);
    if (this.state.navigateBack === true) {
      return <Redirect to={this.state.destination} />;
    }
    if (this.state.toLogin === true) {
      return <Redirect to="/login" />;
    }
    if (this.state.toProfile === true) {
      return <Redirect to={currentBaseUrl() + "profile"} />;
    }
    return (
      <div>
        <Navbar logoutParent={this.onLogout} profileParent={this.onProfile} />
        <ToastContainer style={{ zIndex: 9999999 }} />
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="scheduleContent">
            <div className="page-container">
              <p
                className="go-back"
                onClick={this.openWidget.bind(this, "home")}
              >
                &lt; Back
              </p>
              <div className="schedule-container">
                <div className="schedule-item">
                  <h1 className="calendar-title">My Calendar</h1>
                  <CustomCalendar
                    scheduleEvts={this.state.events}
                    onCellClick={this.onCellClick}
                    onDragStop={this.onDragStop}
                    onDragStart={this.onDragStart}
                    eventClick={this.onClicking}
                    resizeStop={this.onResizeStop}
                  />

                  <div className="drag-n-drop">
                    <img src={dragDropIcon} alt="drag and drop icon" />
                    <p>
                      If you wish to reschedule a lesson, drag it from the day
                      it is scheduled and drop it in the day you want to
                      reschedule it.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default DNDCalendar;



// WEBPACK FOOTER //
// ./src/pages/SingleLesson/scheduleLessons.Component.js